<p style="margin: auto; text-align: center; margin-top: 60px;">
  Welcome, {{name}}
</p>
